import {axiosApi as axios} from '../helpers/axiosApi';


const RESET_PASSWORD_API = "/accounts/reset-password/";
const RESET_PASSWORD_CONFIRM_API = "/accounts/reset-password/confirm/";


export const resetPasswordAPI = (email) => {
  const payload = {'email': email}
  return axios.post(
    RESET_PASSWORD_API, payload
  ).then(res => {
    return res.data;
  })
}

export const resetPasswordConfirmAPI = (token, password) => {
  const payload = {'token': token, 'password': password}
  return axios.post(RESET_PASSWORD_CONFIRM_API, payload).then(res => {return res.data;})
}
